<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DDLNjS/tc-custom/9780226772967.jpg?1730578246404" alt="This image is the cover for the book Deadly Edge, The Parker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Edge, The Parker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Deadly Edge</i> bids a brutal adieu to the 1960s as Parker robs a rock concert, and the heist goes south. Soon Parker finds himself—and his woman, Claire—menaced by a pair of sadistic, strung-out killers who want anything but a Summer of Love. Parker has a score to settle while Claire’s armed with her first rifle—and they’re both ready to usher in the end of the Age of Aquarius.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Stark, Charles Ardai
      </h2>
      
      <p class="authorDescription body article"><P><B>Richard Stark</B> was one of the many pseudonyms of Donald E. Westlake (1933–2008), a prolific author of noir crime fiction. In 1993, the Mystery Writers of America bestowed the society’s highest honor on Westlake, naming him a Grand Master.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08524b54